import "./ClientTable.css";

export default function ClientTable({
  clients,
  onEdit,
  onDelete
}) {
  const clientList = clients || [];

  return (
    <div className="table-container">

      {/* =========================
          TABLEAU
      ========================= */}

      {clientList.length === 0 ? (

        <div className="no-clients-found">

          <div className="no-clients-icon">
            👤
          </div>

          <h3>
            Aucun client
          </h3>

          <p>
            Aucun client n'est enregistré.
          </p>

        </div>

      ) : (

        <div className="responsive-table-wrapper">

          <table className="responsive-table">

            <thead>

              <tr>
                <th>Client</th>
                <th>Téléphone</th>
                <th>Adresse</th>
                <th>Email</th>
                <th>Actions</th>
              </tr>

            </thead>

            <tbody>

              {clientList.map((client) => (

                <tr key={client.id}>

                  {/* =========================
                      CLIENT
                  ========================= */}

                  <td data-label="Client">

                    <strong>
                      {client.nom || "-"}
                    </strong>

                  </td>


                  {/* =========================
                      TELEPHONE
                  ========================= */}

                  <td data-label="Téléphone">

                    {client.telephone ? (

                      <a
                        href={`tel:${client.telephone}`}
                        className="phone-link"
                      >
                        📞 {client.telephone}
                      </a>

                    ) : (

                      <span className="empty-value">
                        -
                      </span>

                    )}

                  </td>


                  {/* =========================
                      ADRESSE
                  ========================= */}

                  <td data-label="Adresse">

                    {client.adresse || (

                      <span className="empty-value">
                        -
                      </span>

                    )}

                  </td>


                  {/* =========================
                      EMAIL
                  ========================= */}

                  <td data-label="Email">

                    {client.email ? (

                      <a
                        href={`mailto:${client.email}`}
                        className="email-link"
                      >
                        {client.email}
                      </a>

                    ) : (

                      <span className="empty-value">
                        -
                      </span>

                    )}

                  </td>


                  {/* =========================
                      ACTIONS
                  ========================= */}

                  <td data-label="Actions">

                    <div className="client-actions">

                      <button
                        type="button"
                        className="btn edit"
                        onClick={() => onEdit(client)}
                        title="Modifier le client"
                      >
                        ✏️
                      </button>


                      <button
                        type="button"
                        className="btn delete"
                        onClick={() => onDelete(client.id)}
                        title="Supprimer le client"
                      >
                        🗑️
                      </button>

                    </div>

                  </td>

                </tr>

              ))}

            </tbody>

          </table>

        </div>

      )}

    </div>
  );
}